import { motion } from "framer-motion";
import { SERVICES } from "../lib/site";

export const Services = () => {
  return (
    <section id="services" data-testid="services-grid" className="relative py-24 md:py-36 border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="overline text-[#B87333]">/ What We Do</span>
            <h2 className="font-serif text-[clamp(2rem,5vw,4.5rem)] leading-[1.02] tracking-[-0.02em] mt-6">
              Capabilities
            </h2>
          </div>
          <p className="max-w-sm font-body text-[#8A8A82] leading-relaxed">
            A comprehensive suite of bulk-trading and supply-chain services, engineered for organized businesses at scale.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden rounded-sm border border-white/10 min-h-[320px] md:min-h-[420px] ${s.span}`}
            >
              <img
                src={s.img}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-[900ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070707] via-[#070707]/50 to-transparent" />
              <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-10">
                <span className="font-grotesk text-xs tracking-[0.2em] text-[#B87333]">0{i + 1}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-4xl text-[#F5F5F0] mb-3">{s.title}</h3>
                  <p className="font-body text-[#C9C9C2] max-w-md leading-relaxed translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                    {s.desc}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
